<!-- eslint-disable vue/no-confusing-v-for-v-if -->
<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <main class="main main--has-floating-buttons">
    <card :title="$t('pageFindGuestOffer.card.offers')" cols="12">
      <hm-card-inner>
        <hm-input v-model="search.name"
                  :lazy="false"
                  :label="$t('pageFindGuestOffer.search_input')"
                  name="search"
                  cols="12 2@hd 2@desktop 6@tablet"
                  @blur="updateSearch()">
          <template slot="icon-inline-left" slot-scope="slot">
            <icon icon="search" />
          </template>
          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button v-if="!isEmpty(search.name)" :border="false" icon="close-text" @click="search.name = null" />
          </template>
        </hm-input>
        <hm-input v-model="filter"
                  :lazy="false"
                  :label="$t('pageFindGuestOffer.filter')"
                  name="filter"
                  cols="12 2@hd start-11@hd 3@desktop start-10@desktop 6@tablet start-7@tablet">
          <template slot="icon-inline-left" slot-scope="slot">
            <icon icon="filter" />
          </template>
          <template slot="icon-inline-right" slot-scope="slot">
            <input-icon-button v-if="!isEmpty(filter)" :border="false" icon="close-text" @click="filter = null" />
          </template>
        </hm-input>
      </hm-card-inner>
      <hm-card-inner v-if="rows.length === 0">
        <h1 class="col-12">{{ $t('pageFindGuestOffer.search.noResults') }}</h1>
      </hm-card-inner>
      <hm-card-inner v-if="rows.length > 0" :full-size="true">
        <paginated-table :items-per-page="25"
                         :rows="filteredRows"
                         :sticky="true"
                         min-width="600px"
                         columns="9 5@mobile">
          <template slot="table-head">
            <div class="hm-table__th">{{ $t('pageFindGuestOffer.search.offerNumber') }}</div>
            <div class="hm-table__th">{{ $t('pageFindGuestOffer.search.name') }}</div>
            <div class="hm-table__th">{{ $t('pageFindGuestOffer.search.arrivalDate') }}</div>
            <div class="hm-table__th">{{ $t('pageFindGuestOffer.search.departureDate') }}</div>
            <div class="hm-table__th hidden@mobile">{{ $t('pageFindGuestOffer.search.numAdults') }}</div>
            <div class="hm-table__th hidden@mobile">{{ $t('pageFindGuestOffer.search.numChildren') }}</div>
            <div class="hm-table__th hidden@mobile">{{ $t('pageFindGuestOffer.search.roomCount') }}</div>
            <div class="hm-table__th hidden@mobile">{{ $t('pageFindGuestOffer.search.createdAt') }}</div>
            <div class="hm-table__th">{{ $t('pageFindGuestOffer.search.status') }}</div>
          </template>
          <template v-slot:default="slotProps">
            <template v-for="row in slotProps.currentPage">
              <div class="hm-table__td" @click="openOffer(row.id)">{{ row.number }}</div>
              <div class="hm-table__td privacy--blur" @click="openOffer(row.id)">{{ row.guestName || row.companyName }}</div>
              <div class="hm-table__td" @click="openOffer(row.id)">{{ row.arrivalDate | moment($moment.localeData().longDateFormat('L')) }}</div>
              <div class="hm-table__td" @click="openOffer(row.id)">{{ row.departureDate | moment($moment.localeData().longDateFormat('L')) }}</div>
              <div class="hm-table__td hidden@mobile" @click="openOffer(row.id)">{{ row.numAdults }}</div>
              <div class="hm-table__td hidden@mobile" @click="openOffer(row.id)">{{ row.numChildren }}</div>
              <div class="hm-table__td hidden@mobile" @click="openOffer(row.id)">{{ row.roomCount }}</div>
              <div class="hm-table__td hidden@mobile" @click="openOffer(row.id)">{{ isEmpty(row.createdAt) ? '' : $options.filters.toLocalDateTime($moment.utc(row.createdAt, 'YYYYMMDDHHmmss').toISOString()) }}</div>
              <div class="hm-table__td" @click="openOffer(row.id)">{{ $t(`GuestOfferStatus.${row.status}`) }}</div>
            </template>
          </template>
        </paginated-table>
      </hm-card-inner>
    </card>
    <hm-floating-buttons>
      <hm-floating-button :label="$t('pageFindGuestOffer.actions.createOffer')" icon="plus" color="blue" @click="addOffer" />
    </hm-floating-buttons>
  </main>
</template>

<script>
/* eslint func-names: 0 */

import HotelmeisterMixin from '@/mixins/HotelmeisterMixin';
import { isArray, join, isNil, isEmpty, get, filter, last, find, nth, template, clone, cloneDeep, isEqual, isObject, debounce, lowerCase } from 'lodash';
import HmCol from '../lib/layout/HmCol';
import HmTable from '../lib/table/HmTable';
import { util } from 'protobufjs/minimal';
import HmCardInner from '../lib/layout/HmCardInner';
import FilterMixin from '../../mixins/FilterMixin';

export default {
  name: 'PageFindGuestOffer',
  components: { HmCardInner, HmCol, HmTable },

  mixins: [HotelmeisterMixin, FilterMixin],
  props: ['test'],

  data() {
    return {
      search: {
        name: null,
      },
      lastSearch: null,
      filter: null,
      rows: [],
      debouncedUpdateSearch: null,
    };
  },

  computed: {
    filteredRows: function () {
      if (isEmpty(this.filter)) return this.rows;
      return this.rows.filter(it => Object.values(it).filter(str => !isEmpty(str) && lowerCase(str).indexOf(lowerCase(this.filter)) >= 0).length > 0);
    },
  },

  watch: {
    'search.name': function () {
      this.onChangeInput();
    },
  },

  created: function () {
    this.debouncedUpdateSearch = debounce(this.updateSearch, 250);
    this.updateSearch();
  },

  methods: {
    openOffer: function (offerId) {
      this.$router.push({ name: 'offer', params: { guestOfferId: offerId } });
    },
    addOffer: function () {
      this.$router.push({ name: 'createReservation' });
    },
    onClickSearch: function () {
      this.updateSearch();
    },
    onChangeInput: function () {
      if (!isNil(this.debouncedUpdateSearch)) {
        this.debouncedUpdateSearch();
        this.filter = null;
      }
    },
    updateSearch: function () {
      const currentSearch = cloneDeep(this.search);

      if (isEqual(currentSearch, this.lastSearch)) {
        return;
      }

      this.axios.get(this.serviceUrl('offer.find'), {
        params: {
          q: currentSearch.name,
        },
      })
        .then((response) => {
          this.rows = response.data.data;
          this.rows.forEach((it) => {
            it.statusText = this.$t(`GuestOfferStatus.${it.status}`);
            it.arrivalDateText = this.$options.filters.toDate(it.arrivalDate);
            it.departureDateText = this.$options.filters.toDate(it.departureDate);
          });

          this.lastSearch = currentSearch;
        });
    },
  },
};
</script>

<!-- Scoped SCSS  -->
<style lang="scss" scoped>
  @import '~styles/import';

  .hm-table__td {
    cursor: pointer;
  }
</style>

<style lang="scss">
  @import '~styles/import';

</style>



// WEBPACK FOOTER //
// src/components/pages/PageFindGuestOffer.vue